import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body6 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-sm',
          'text-xs',
          'text-gray-800',
          'font-normal',
          'leading-normal tracking-wide',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body6.displayName = 'Body6'

export default Body6
